import { MReportTemplateAPI, MReportTemplateListResponse } from "api/sysadmin/m_report_template_api";
import { Messages } from "app_constants";
import axios from "axios";
import ReqState from "lib/reqstate";
import { useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import { Table, Button, Modal } from "react-bootstrap";
import Loading from "components/Loading";
import FooterMenu from "components/Footermenu";
import ImgPencilFill from "assets/pencil-fill.svg";


export default function TemplateListPage() {
  const navigate = useNavigate();
  const [records, setRecords] = useState<MReportTemplateListResponse>([]);
  const [loadingState, setLoadingState] = useState(ReqState.INIT);
  const [sendingState, setSendingState] = useState(ReqState.INIT);
  const [selectedId, setSelectedId] = useState("");
  const [errorMsg] = useState(Messages.ServerError);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    async function fetchData() {
      try {
        const res = await MReportTemplateAPI.list(abortController.signal);
        setRecords(res);
        setLoadingState(ReqState.DONE);
      }
      catch (ex: unknown) {
        if (axios.isCancel(ex)) {
          return;
        }
        setLoadingState(ReqState.ERROR);
      }
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, []);


  function handleDeleteClick(id: string) {
    setSelectedId(id);
    setIsDeleteDialogOpen(true);
  }


  async function deleteTemplate() {
    const abortController = new AbortController();
    setSendingState(ReqState.DOING);
    try {
      await MReportTemplateAPI.delete(selectedId, abortController.signal)
      setSendingState(ReqState.DONE);
      setIsDeleteDialogOpen(false);
    }
    catch(ex) {
      if (axios.isCancel(ex)) {
        return;
      }

      setSendingState(ReqState.ERROR);
      setIsDeleteDialogOpen(false);
    }
  }


  return (
    <>
      <Loading
        isLoading={loadingState != ReqState.DONE}
        isLoadError={loadingState == ReqState.ERROR}
        isSendError={sendingState == ReqState.ERROR}
        errorMsg={errorMsg}
      >
        <Table>
          <thead>
            <tr>
              <th>Id</th>
              <th>delete</th>
              <th>name</th>
              <th>createCycle</th>
              <th>storeCycle</th>
              <th>linkedId</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {records.map((record) => (
              <tr key={record.S}>
                <td>{record.S}</td>
                <td>{record.delete}</td>
                <td>{record.name}</td>
                <td>{record.createCycle}</td>
                <td>{record.storeCycle}</td>
                <td>{record.linkedIds.join(",")}</td>
                <td>
                  <Button
                    onClick={() => navigate(`/designer/${record.S}`)}
                  >
                      テンプレート編集
                  </Button>
                </td>
                <td>
                  <Button
                    onClick={() => handleDeleteClick(record.S)}
                  >
                      削除
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        
      </Loading>
      <FooterMenu height="80px" right="10px" bottom="10px">
        <Button variant="primary" className="btn-circle-md"
          onClick={() => navigate(`/designer/`)}
        >
          <img src={ImgPencilFill} alt="テンプレート新規作成" className="btn-circle-md" />
        </Button>
      </FooterMenu>
      <Modal show={isDeleteDialogOpen} animation={false}>
        <Modal.Header>
          <Modal.Title>
            確認
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          削除しますか？
        </Modal.Body>
        <Modal.Footer>
          <Loading
            isLoading={sendingState === ReqState.DOING}
          >
            <Button variant="secondary" onClick={() => setIsDeleteDialogOpen(false)}>キャンセル</Button>
            <Button onClick={() => deleteTemplate()}>削除する</Button>
          </Loading>
        </Modal.Footer>
      </Modal>
    </>
  );
}
